// Sidebar.jsx
import React from "react";
import classes from "./sidebar.module.css";

const Sidebar = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <aside className={classes.sidebar}>
      <div className={classes.logo}>
        <h2>ArtistNextDoor</h2>
        <p>Voting Arena</p>
      </div>

      <nav className={classes.categoryNav}>
        <h3>Contest Categories</h3>
        <ul>
          {categories.map((category) => (
            <li key={category.id}>
              <button
                className={`${classes.categoryButton} ${
                  activeCategory === category.id ? classes.active : ""
                }`}
                onClick={() => onCategoryChange(category.id)}
              >
                {category.name}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className={classes.sidebarFooter}>
        <p>© 2025 ArtistNextDoor</p>
      </div>
    </aside>
  );
};

export default Sidebar;
